"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZipLookupReply = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.ZipLookupReply = typebox_1.Type.Object({
    zip: typebox_1.Type.String(),
    city: typebox_1.Type.Optional(typebox_1.Type.String()),
    state: typebox_1.Type.Optional(typebox_1.Type.String()),
    kmlFragment: typebox_1.Type.String(),
    geoJSON: typebox_1.Type.Optional(typebox_1.Type.String()),
});
//# sourceMappingURL=zip-code.js.map